import { QualityStandardsScreen } from './quality-standards-screen'

export { QualityStandardsScreen }